module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-mv.fa49fefa.png";